import React from 'react';

// LOCAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// LOCAL VARIABLES
import { EMPLOYEE_OPTION_KEYS, LOOKUP_PARAMS } from '../../../variables';

// STYLES
import styles from '../../trade.module.scss';

// VARIABLES
const TODAY = new Date();

// RENDER
const PurchaseInfoForm = ({ index }) => {
  // RENDER
  return (
    <Form.Body.Vertical className={styles.body} fullWidth>
      <Form.Date
        name={`aryTrade[${index}].inventory.purchase_date`}
        label="Purchase Date"
        text="* Must be the date on the Seller's Bill of Sale"
        maxDate={TODAY}
        required
      />
      <Form.PlainText value={'Dealer DX'} label="Source" />
      <Form.Control name={`aryTrade[${index}].inventory.source_name`} label="Source Name (DX from Dealer Name):" />
      <Form.Select
        name={`aryTrade[${index}].inventory.appraised_by_user_id`}
        label="DX Transacted / Acquired By"
        lookup="salesManagers"
        lookupParams={LOOKUP_PARAMS.salesManager}
        optionKeys={EMPLOYEE_OPTION_KEYS}
        required
      />
    </Form.Body.Vertical>
  );
};

export default function PurchaseInfo(props) {
  return <Card title="Purchase Info" body={<PurchaseInfoForm {...props} />} />;
}
